// This file must be imported first in index.js to suppress benign errors
if (typeof window !== 'undefined') {
    const resizeObserverErr = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/i;

    // Capture phase to intercept early
    window.addEventListener('error', (event) => {
        const msg = String(event?.message || '');
        if (resizeObserverErr.test(msg)) {
            event.stopImmediatePropagation();
            event.preventDefault();
        }
    }, true);

    // Some libs surface it via unhandledrejection
    window.addEventListener('unhandledrejection', (event) => {
        const reason = event?.reason;
        const msg = reason && (reason.message || String(reason)) || '';
        if (resizeObserverErr.test(String(msg))) {
            event.preventDefault();
        }
    });

    // Override console.error to catch it if it's logged directly
    const originalConsoleError = console.error;
    console.error = function (...args) {
        try {
            if (args && args.length) {
                const first = args[0];
                const msg = typeof first === 'string' ? first : (first && first.message) || '';
                if (resizeObserverErr.test(String(msg))) return;
            }
        } catch { }
        return originalConsoleError.apply(console, args);
    };
}
